'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactTransitionGroup = require('react-transition-group');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DropOver = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(DropOver, _React$Component);

  function DropOver() {
    (0, _classCallCheck3.default)(this, DropOver);
    return (0, _possibleConstructorReturn3.default)(this, (DropOver.__proto__ || Object.getPrototypeOf(DropOver)).apply(this, arguments));
  }

  (0, _createClass3.default)(DropOver, [{
    key: 'renderMenu',
    value: function renderMenu() {
      if (!this.props.open) return;
      return _react2.default.createElement(
        _reactTransitionGroup.CSSTransition,
        { classNames: 'os_dropover', key: 'menu', timeout: { enter: 200, exit: 200 } },
        this.props.children
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactTransitionGroup.TransitionGroup,
        null,
        this.renderMenu()
      );
    }
  }]);
  return DropOver;
}(_react2.default.Component), _class.propTypes = {
  open: _propTypes2.default.bool,
  children: _propTypes2.default.node
}, _temp);
exports.default = DropOver;